import { HttpClient, Result, Failure, Success } from './httpClient';
import { EnvironmentExtended } from '../../../environment/index';
import { Environment, SleepUtility } from '@mchs/web-core';

export class FetchHttpClient implements HttpClient {
  public async get(
    url: string,
    token: string | undefined,
    query: { [key: string]: string | number | boolean }
  ): Promise<Result> {
    // Format the query string for the get request.
    const urlWithQueryString = url + '?' + this.generateQueryString(query);

    const request: RequestInit = {
      method: 'GET',
      credentials: this.getCredentials(),
      headers: this.getHeaders(token),
    };

    return await this.executeHttpRequest(urlWithQueryString, request);
  }

  public async post(
    url: string,
    token: string | undefined,
    query: { [key: string]: string | number | boolean }
  ): Promise<Result> {
    const request: RequestInit = {
      method: 'POST',
      credentials: this.getCredentials(),
      headers: this.getHeaders(token),
      body: JSON.stringify(query),
    };

    return await this.executeHttpRequest(url, request);
  }

  private async executeHttpRequest(
    url: string,
    request: RequestInit
  ): Promise<Result> {
    try {
      // Check if service latency is turned on.  If so, we'll sleep here
      // for the specified amount of time.
      const latency = Environment.serviceCallLatency();
      if (latency > 0) {
        await SleepUtility.sleepAsync(latency);
      }

      // Make the http request.
      const response = await window.fetch(url, request);

      /* Check if the response is ok.  Return success if all is good, otherwise return failure. */
      if (response.ok) {
        // Get the JSON data from the response.
        const data = await response.json();
        return new Success({ data: data });
      } else {
        return new Failure(
          {
            status: response.status,
            data: response.statusText,
          },
          response.status === 401 ? false : true
        );
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      return new Failure(error, false);
    }
  }

  private getCredentials(): RequestCredentials {
    return 'include';
  }

  private getHeaders(
    token: string | undefined
  ): HeadersInit {
    return {
      accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Api-Key': EnvironmentExtended.getApiKey(),
      ...(token && { 'X-Auth-Token': token }),
      //Authorization: 'Bearer ' + token, // Not sure why it doesn't like this, possibly conflicting with browser built-in NTLM authorization?
    };
  }

  private generateQueryString(obj: {
    [key: string]: string | number | boolean;
  }): string {
    const str = [];
    for (const p in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
      }
    }
    return str.join('&');
  }
}
